export const ACCESS_TOKEN_KEY = "at";
export const REFRESH_TOKEN_KEY = "rt";
export const LOGIN_PAGE_URL = "/login";
